// Composer domain slice: the busy/error state for the submit path.
//
// - `isSubmitting`/`uploadError` are provider-owned (gate the composer / carry the
//   upload error banner) and driven directly through the slice actions.
// - `botLoading` originates in the query-layer block's operation response, which publishes
//   it here itself — no provider effect-bridge. It gates the composer and the "thinking"
//   indicator. The bot RESPONSE is deliberately not here: it is an event, delivered to the
//   root as a callback, not state anything renders (Seq F.d).
//
// The file-upload artifact state (imageData / isLoading / documentFile /
// isDocumentLoading) is its own domain — see fileUploadSlice.
export const composerSlice = (set) => ({
  isSubmitting: false,
  setIsSubmitting: (value) => set({ isSubmitting: value }),
  uploadError: null,
  setUploadError: (error) => set({ uploadError: error }),
  botLoading: false,
  setBotLoading: (value) => set({ botLoading: value }),
});
